// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "c54b8096",
    "hash": "c54b8096",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c54b8096",
    "semverString": null,
    "version": "2026.10.0.10"
};
/* tslint:enable */
